import React from 'react';

const Banner: React.FC = () => {
  return (
    <div id="banner-wrapper">
      <div id="banner" className="box container">
        <div className="row">
          <div className="col-7 col-12-medium">
            <h2>컴퓨터그래픽스 연구실(SCH CGLAB)</h2>
            <p>순천향대학교 컴퓨터그래픽스 연구실에서는 다음과 같은 연구를 수행하고 있습니다.              
               <li>물리 기반 실시간 시뮬레이션(Physically Based Real-time Simulation)</li>
               <li>GPU 기반 병렬처리 기법(Gpu Parallel Processing)</li>
               <li>영상, 센서 등 의료 데이터를 기반으로 한 머신러닝(Machine Learning)</li>
            </p>
          </div>
          <div className="col-5 col-12-medium">
            <ul>
              <li><a href="/projects" className="button icon fa-arrow-circle-right">프로젝트</a></li>
              <li><a href="/publications" className="button icon fa-arrow-circle-right">출간논문</a></li>
              <li><a href="/alumni" className="button icon fa-arrow-circle-right">졸업생 현황</a></li>
            </ul>
          </div>
        </div>
      </div>      
    </div>
  );
};

export default Banner;
